var _path, _g, _path2, _path3, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIacriteriaicon = function SvgIacriteriaicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#07295a",
    d: "m111.1 113.5 2.9-2.4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m69.4 150.2-2.8-3-5.5-5.7c-5.1-4.1-9.6-10.4-14.6-14.5s-.8-.3-1.1-.5 0-.3 0-.3H45c-.1-.2.2-.3.2-.4.1 0 .2.4.2.4.3.1 1.1.2 1.4.2 13.4.8 28-.5 41.4-.2 5.5.5 11 .2 16.5 0 .5-1.6.1-3.8-.6-5.3-3.1-6.1-10-4.5-15.6-4.4l-8.7-.2-.2-21.1c0-7.1.2-1 .2-1.5V47.6l3.7-3.7 21 .2c7-.1 1-.2 1.5-.2s9-.1 9.6-.5c2-1.1 2.6-3.7 1.9-5.8.4 0 .5.3.8.5 10 9.1 19.4 19.8 29.2 29.3.5.5 2.6 2 2.6 2v80.7M45.2 123.5s-.2-.2-.2-.6c0-.8.8-2.3 1.3-3s1.9-1.8 1.5-2.5L26.5 96.1c6.5 3.3 13.7 4.1 20.7 1.6s7.7-4.3 10-7.8 2.6-5.1 1.9-7.1-2.6-.2-3.3-1.6l-15-37.1H67l3.3 3.3V116l-.3.3H52.8c-1.2 0-3.7 1.2-4.7 2-1.6 1.3-2.5 3.3-3 5.2zM79.3 22.3c.4 0 .5.3.8.5 4 3.7 7.6 7.7 11.6 11.5 7.1.2 14.2-.2 21.3 0s.8-.2.7.4c-8.1-.2-16.4 0-24.5 0h-5.9l-3.5-4c-.4-2.7.4-5.8-.5-8.4",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2 123.9v1.5h-.4V124h.4z",
    opacity: 0.2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#21366c",
    strokeMiterlimit: 10,
    strokeWidth: 3.4,
    d: "m22.6 83.2 16.1-40.6L55 83.2zm72.7 0 16.1-40.6 16.3 40.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "m117.2 37-.4-.2s.2 0 .4.2",
    opacity: 0.2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#21366c",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fdfdfd",
    strokeWidth: 3.4,
    d: "m83.3 43.7-3.7 3.7c-.3 15.4 0 30.7 0 46.1 0 .5-.2 1-.2 1.5l.2 21.1 8.7.2c5.7-.2 12.6-1.7 15.6 4.4s1.1 3.7.6 5.3c-5.5.2-11 .5-16.5 0-13.4-.3-28 1.1-41.4.2s-1.2 0-1.4-.2 0-.3-.2-.4v-2.3c.5-2 1.4-3.9 3-5.2s3.4-2 4.7-2h17.2l.3-.3V47.2l-3.3-3.3-30.8-.2c-5.2-.9-4.8-9.3.7-9.3h30.1l3.3-3.9c.2-3.3-1.4-8.7 2.5-10.4s3.8-.5 5.5.9l.6.6c.1.2.3.5.4.8.8 2.6 0 5.7.5 8.4l3.5 4h30.4c8.2.2.3 0 .4 0 .2.3.6.3 1 .4s.3 0 .4 0l.2.2c.5.4 1 1.1 1.3 1.5l.4.2s.1.4.2.6c.7 2.1 0 5.2-2 6.3s-25 0-32 0z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fbbf03",
    d: "M77.6 33c2.8 2 4.7 4 3.5 7.8-2.2 7.4-14.6 4.3-12.4-3.6s2.2-3.3 3.9-4.6 1-.4 1.3-.9.6-2.3 1.2-2.3c1 0 1.2 2.5 1.6 3.1s.5.3.7.5zm-3.5 3.7c-2.1.5-2 4.2.7 4.3s2.7-5.2-.7-4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21366c",
    d: "M77.6 33c-.3-.2-.5-.2-.7-.5-.5-.6-.7-3.1-1.6-3.1s-1 1.9-1.2 2.3-1 .7-1.3.9l1.7-6.8c.4-.4.7-.4 1.1 0 .6.9 1.4 3.8 2.1 7.2z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fbbf03",
    strokeWidth: 3.4
  }, /*#__PURE__*/React.createElement("use", {
    href: "#iacriteriaicon_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 72.7,
    href: "#iacriteriaicon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#082a5e",
    strokeWidth: 0.2,
    d: "M74.1 36.7c3.4-.9 4.3 4.5.7 4.3s-2.8-3.8-.7-4.3Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "iacriteriaicon_svg__a",
    d: "M58.4 83.2c.5.6-1.6 4.7-2 5.4-8.5 14.9-32.2 12.8-37.3-4.8l.3-.6z"
  }))));
};
export default SvgIacriteriaicon;